import React from 'react';
import classNames from 'classnames';
import { ButtonProps } from './ButtonProps';
import { Link } from 'gatsby';

export const Button = ({
	url,
	className,
	children,
	primary,
	outline,
	target,
	...props
}: ButtonProps): JSX.Element => {
	return (
		<Link
			to={url}
			className={classNames('btn', className, {
				'btn-orange': primary,
				outline: outline,
			})}
			target={target}
			{...props}
		>
			{children}
		</Link>
	);
};
